<template>
  <section class="embed-frame product--embed">
    <span class="embed-frame-loading">
      <context-loading />

      {{ placeholder }}
    </span>

    <div
      id="credere-embed-app"
      class="embed-frame-content"
    />
  </section>
</template>

<script>
  /* eslint no-underscore-dangle: ['error', { allow: ['_INTERNAL'] }] */

  import { mapState } from 'vuex';

  import ContextLoading from '@cordel/components/Context/Loading.vue';

  export default {
    name: 'EmbedFrame',
    components: {
      ContextLoading,
    },
    props: {
      settings: {
        type: Object,
        default: () => ({}),
      },
      callbacks: {
        type: Object,
        default: () => ({}),
      },
      endpoint: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: 'Carregando...',
      },
    },
    computed: {
      ...mapState([
        'auth',
      ]),
    },
    watch: {
      settings(before, after) {
        let changed = true;

        try {
          if (true
            && before.simulations.read.uuid && after.simulations.read.uuid
            && typeof before.simulations.read.uuid !== typeof after.simulations.read.uuid
          ) {
            changed = false;
          }
        } catch (err) { /* */ }

        if (changed) {
          this.mount();
        }
      },
    },
    mounted() {
      this.mount();
    },
    methods: {
      mount() {
        this.initialize();
      },
      initialize() {
        const { CREDERE } = window;

        CREDERE._INTERNAL = CREDERE._INTERNAL || {};
        CREDERE._INTERNAL.endpoint = this.endpoint;

        /*
         * `CREDERE._INTERNAL.navigation` NÃO É DECLARADO AQUI, DE PROPÓSITO, e o default do
         * contrato (`client`) é o que vale: o embed desce a cortina (`home-blank`) ao emitir
         * a mensagem, para a tela que saiu não ficar viva atrás da que o host está montando.
         *
         * O MODO NÃO É DESTE COMPONENTE, É DO DESTINO DA CALLBACK. Toda callback daqui é
         * `$router.push`, mas parte dos hosts empurra para rota com `meta.external`, e essa o
         * `beforeEach` (`src/router/index.js`) resolve com `window.location.href` - troca de
         * DOCUMENTO, onde a cortina não esconde nada e só pisca "204" durante o round trip.
         * E um host mistura os dois: `Simulations/Read` abre o cadastro de cliente, externo,
         * ou outro resultado de simulação, que é tela daqui.
         *
         * Declarar um modo só aqui seria afirmar do frame o que é fato de cada tela. Quando
         * valer a pena calar o pisca, o modo vira prop deste componente e cada host passa o
         * seu; até lá, o default é o conservador dos dois.
         */

        CREDERE.element = '#credere-embed-app';
        CREDERE.settings = this.settings;
        CREDERE.callbacks = this.callbacks;

        CREDERE.src = `${process.env.VUE_APP_EMBED_URL}/${this.endpoint}`;

        CREDERE._INTERNAL.defer();

        if (CREDERE.reinitialize) {
          CREDERE.reinitialize();
        }
      },
    },
  };
</script>

<style lang="scss">
  .product--embed {
    #credere-embed-app {
      --padding: 0;
    }
  }
</style>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .embed-frame {
    min-height: var(--cordel-legacy-spacing-xxblaster);
    padding: 0;
    position: relative;
  }

  .embed-frame-content {
    position: relative;
  }

  .embed-frame-loading {
    align-items: center;
    bottom: 0;
    display: flex;
    flex-direction: row;
    gap: var(--cordel-legacy-spacing-xxxs);
    justify-content: center;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
  }
</style>
